<template>
  <div class="word-definition" :class="{ vip: userStore.isMembers }">
    <audio src="" ref="wordAudio"></audio>
    <el-dialog
      class="word-dialog"
      @open="stopAllAudio()"
      destroy-on-close
      v-model="dialogVisible"
      width="738px"
      align-center
      :before-close="handleClose"
    >
      <template #header>
        <div style="display: flex; justify-content: space-between; align-items: flex-start">
          <span class="title" :class="{ vip: userStore.isMembers }">
            <span class="word">{{ Tips }}</span>
            <div
              v-yt-push="{ btnName: `单词释义-复制` }"
              id="copy-word"
              class="copy"
              @click="copyText(Tips || '')"
            ></div>
          </span>
          <div class="btn">
            <div
              v-yt-push="{ btnName: `单词释义-取消收藏` }"
              @click="cancelCollectWord"
              style="display: flex; align-items: center"
              v-if="data && data?.color > 0"
            >
              <span
                class="yt-collect"
                :class="[`color-${data?.color}`]"
                style="width: 14px; height: 17px"
              ></span>
              <span class="text">取消收藏</span>
            </div>
            <div class="line" v-if="data && data?.color > 0"></div>
            <span
              v-yt-push="{ btnName: `单词释义-进入收藏夹` }"
              v-if="data && data?.color > 0"
              @click="toInfo()"
              class="collect-text"
              >已加入，进入收藏夹
              <el-icon size="16">
                <ArrowRight />
              </el-icon>
            </span>
            <div
              v-yt-push="{ btnName: `单词释义-收藏` }"
              v-else
              @click="addCollectWord"
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                cursor: pointer;
              "
            >
              <div class="yt-collect" :class="[`color-${data?.color}`]"></div>
              <span style="color: var(--el-text-color-secondary)"> 收藏 </span>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div v-loading="loading">
          <div class="accent">
            <div
              v-yt-push="{ btnName: `单词释义-播放英式发音` }"
              v-if="data?.audio"
              :class="{ vip: userStore.isMembers }"
              class="accent-item"
              @click="play(data?.audio, 0)"
            >
              <SvgIcon
                name="icon-speaker"
                class="sprite-audio-icon play-status-icon"
                :class="{ playing: audioIndex === 0 && !audioPaused }"
              />
              英 {{ data?.ukPhonetic || '/暂无音标/' }}
            </div>
            <div
              v-yt-push="{ btnName: `单词释义-播放美式发音` }"
              v-if="data?.audioAm"
              :class="{ vip: userStore.isMembers }"
              class="accent-item"
              @click="play(data?.audioAm, 1)"
            >
              <SvgIcon
                name="icon-speaker"
                class="sprite-audio-icon play-status-icon"
                :class="{ playing: audioIndex === 1 && !audioPaused }"
              />
              美 {{ data?.usPhonetic || '/暂无音标/' }}
            </div>
          </div>
          <div class="word-info">
            <div class="explanations">
              <p class="explanation-item" v-for="item in data?.explanations">
                <span class="dto"></span>
                <span class="label">{{ item.type }}</span>
                <span class="text">{{ item.content }}</span>
              </p>
            </div>
            <div class="word-forms" v-if="data?.wordForms && data.wordForms.length">
              <div class="title">词形变化</div>
              <div class="word-forms-box">
                <p class="word-forms-item" v-for="item in data?.wordForms">
                  <span class="label">{{ item.extendedFormType }}</span>
                  <span class="text">{{ item.extendedFormWord }}</span>
                </p>
              </div>
            </div>
            <div class="examples-phrases">
              <div class="examples" v-if="data?.bilingualExamples && data.bilingualExamples.length">
                <div class="title">双语例句</div>
                <div class="example-list">
                  <div class="example-item" v-for="item in data?.bilingualExamples">
                    <div class="dto"></div>
                    <div class="example-info">
                      <p class="e" v-html="highlightWord(item.source, data.word)"></p>
                      <p class="c">{{ item.target }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="phrases" v-if="data?.dictionaryPhrases && data.dictionaryPhrases.length">
                <div class="title">词典短语</div>
                <div class="phrases-list">
                  <div class="phrases-item" v-for="item in data?.dictionaryPhrases">
                    <div class="dto"></div>
                    <p>{{ item }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="audio-section" v-if="sectionResult">
            <p class="item" v-if="sectionResult.syllables">
              测评报告发音：/<span
                class="syll"
                :style="{ color: wordsColorStore.scoreToColor(syll.score) }"
                v-for="syll in sectionResult.syllables"
              >
                <template v-for="letter in syll.syls">{{ letter.text }}</template> </span
              >/
            </p>
            <p class="item">
              声音切片：
              <SvgIcon
                v-yt-push="{ btnName: `单词释义-声音切片` }"
                name="icon-speaker"
                class="sprite-audio-icon play-status-icon"
                :class="{ playing: audioIndex === 2 && !audioPaused }"
                @click="play(sectionResult.audioUrl, 2, sectionResult.st, sectionResult.end)"
              />
            </p>
          </div>
          <div class="rec-status-text">
            <p v-if="wordResult.audioUrl">
              我的发音：/<span
                class="syll"
                :style="{ color: wordsColorStore.scoreToColor(syll.score) }"
                v-for="syll in wordResult.syllables"
              >
                <template v-for="letter in syll.syls">
                  {{ letter.text }}
                </template> </span
              >/
            </p>
            <template v-else>
              <p v-if="recStatus === 0">点击录音，测评单词发音问题</p>
              <p v-else>点击按钮结束录音</p>
            </template>
          </div>
          <div class="rec-box" v-loading="recLoading">
            <div class="score" v-show="wordResult.audioUrl">
              <span>{{ wordResult.score }}`</span>
            </div>
            <div class="rec-control">
              <div
                v-loading="linkLoaidng"
                v-yt-push="{ btnName: `单词释义-测评录制` }"
                @click="recStart()"
                v-if="recStatus === 0"
              >
                <img
                  v-if="userStore.isMembers"
                  class="start-btn"
                  src="@/assets/images/icon/luyin-vip.png"
                  alt=""
                />
                <img v-else class="start-btn" src="@/assets/images/icon/luyin@2x.png" alt="" />
              </div>
              <el-progress
                v-yt-push="{ btnName: `单词释义-结束录制` }"
                @click="getScore"
                v-else
                :stroke-width="4"
                :class="{ vip: userStore.isMembers }"
                class="end-btn"
                :color="userStore.isMembers ? '#EB9C60' : 'var(--el-color-primary)'"
                type="circle"
                :percentage="plan"
              >
                <div class="end-rectangle"></div>
              </el-progress>
            </div>

            <div v-show="wordResult.audioUrl" class="rec-audio">
              <div class="btn">
                <img
                  v-yt-push="{ btnName: `单词释义-测评结果播放` }"
                  @click="playWordAudio"
                  v-show="wordAudioPaused"
                  class="play"
                  src="@/assets/images/icon/play.png"
                  alt=""
                />
                <img
                  v-yt-push="{ btnName: `单词释义-暂停` }"
                  @click="playWordAudio"
                  v-show="!wordAudioPaused"
                  class="zt"
                  src="@/assets/images/icon/zt.png"
                  alt=""
                />
                <audio
                  ref="wordAudioRef"
                  @play="onAudioStatus()"
                  @pause="onAudioStatus()"
                  v-show="false"
                  :src="wordResult.audioUrl"
                ></audio>
              </div>
            </div>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script setup lang="ts">
import emitter from '@/utils/mitt'
import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue'
import request from '@/utils/http'
import { ArrowRight } from '@element-plus/icons-vue'
import { router } from '@/router'
import { postCollectApi, type CollectPayload } from '@/api/common.api'
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus'
import { useUserStore } from '@/store/user.store'
import { stopAllAudio, WavRecord } from '@/utils/wav-record'
import { xfXmlParseToScore, type WordScore } from '@/utils/tool'
import { useWordsColor } from '@/store/wordsColor.store'
import { cloneDeep } from 'lodash'
import ClipboardJS from 'clipboard'
const wordsColorStore = useWordsColor()
const userStore = useUserStore()
const ytRecord = new WavRecord()
const wordAudio = ref<HTMLAudioElement>()
const dialogVisible = ref(false)
/** 弹窗打开期间是否成功取消过收藏（关闭弹窗时通知生词收藏列表刷新） */
const collectCanceled = ref(false)
const handleClose = () => {
  dialogVisible.value = false
  wordAudio.value && wordAudio.value.pause()
  ytRecord.cancelRecording()
  recEnd()
  stopAllAudio()
  isStatr.value = false
  recStatus.value = 0
  // 本次打开期间取消过收藏：关闭后通知生词收藏列表刷新状态
  if (collectCanceled.value) {
    collectCanceled.value = false
    emitter.emit('word-collect-cancel', { word: Tips.value })
  }
}

const copyText = (text: string) => {
  console.log(text)

  const clipboard = new ClipboardJS('#copy-word', {
    text: function () {
      return text
    }
  })
    .on('success', function () {
      ElNotification({
        message: '复制成功',
        type: 'success'
      })
      clipboard.destroy()
    })
    .on('error', function () {
      ElNotification({
        message: '复制失败,请手动复制',
        type: 'error'
      })
      ElMessageBox.alert(text, {
        title: '分享结果',
        confirmButtonText: 'OK'
      })
      clipboard.destroy()
    })
}

const audioIndex = ref(-1)
const play = (src: string | undefined, index: number, st?: number, end?: number) => {
  audioIndex.value = index
  if (!src) return
  if (wordAudio.value) {
    if (typeof st === 'number' && typeof end === 'number') {
      wordAudio.value.src = src
      wordAudio.value.currentTime = st
      wordAudio.value.play()
      wordAudio.value.ontimeupdate = () => {
        const currentTime = wordAudio.value!.currentTime as number
        if (currentTime >= end) {
          wordAudio.value?.pause()
        }
      }
      return
    }
    if (wordAudio.value.src === src && !wordAudio.value.paused) {
      wordAudio.value.pause()
    } else {
      wordAudio.value.src = src
      wordAudio.value.play()
    }
  }
}
const toInfo = () => {
  handleClose()
  // 旧收藏夹详情页已下线，跳新收藏夹「生词」tab
  router.push({
    path: '/tools/collect',
    query: { tab: '生词' }
  })
}

const addCollectWord = () => {
  emitter.emit('collect-popup', {
    label: '生词',
    word: Tips.value,
    termName: termName.value,
    qid: qid.value,
    succeed: (color: 1 | 2 | 3 | 4) => {
      if (data.value) {
        data.value.color = color
        getWordInfo(Tips.value)
      }
    }
  })
}

const submitLoading = ref(false)

const cancelCollectWord = () => {
  submitLoading.value = true
  const payload: CollectPayload = {
    label: '生词',
    // id: data.value?.typeId,
    color: 0,
    // WORD 类型 sourceWpId 必填（qid 即来源机经 wpId）
    qid: qid.value
  }
  if (data.value?.word) {
    payload.word = [data.value?.word]
  }

  // 取消收藏
  postCollectApi(payload)
    .then(() => {
      ElMessage.success({
        message: '取消收藏成功！',
        duration: 1500
      })
      if (data.value) {
        data.value.color = 0
      }
      collectCanceled.value = true
    })
    .finally(() => {
      submitLoading.value = false
    })
}

onMounted(() => {
  nextTick(() => {
    if (wordAudio.value) {
      wordAudio.value.addEventListener('play', onPlay)
      wordAudio.value.addEventListener('pause', onPause)
    }
  })
})

const audioPaused = ref(true)
function onPause() {
  audioPaused.value = true
}
function onPlay() {
  audioPaused.value = false
}

const recLoading = ref(false)
let timer = 0
const countDownDefault = 10 //录制时长
const countDown = ref(countDownDefault)
const recStatus = ref<0 | 1>(0)
const resultDefault = {
  audioUrl: '',
  score: 0,
  syllables: []
}
const wordResult = ref<WordScore>(cloneDeep(resultDefault))

const plan = computed(() => {
  return 100 - (countDown.value / countDownDefault) * 100
})
// 开始录制
const isStatr = ref(false)
const linkLoaidng = ref(false)
const recStart = () => {
  if (ytRecord.isRecording) {
    ElMessage.warning('录制中...')
    return
  }
  if (isStatr.value || recLoading.value || linkLoaidng.value) {
    return
  }
  ytRecord.cancelRecording()
  linkLoaidng.value = true
  isStatr.value = true
  ytRecord.start({
    businessText: Tips.value,
    onStart: () => {
      linkLoaidng.value = false
      recStatus.value = 1
      wordResult.value.audioUrl = ''
      ytRecord.isDing = true
      clearTimeout(timer)
      timer = window.setInterval(() => {
        if (countDown.value <= 0) {
          getScore()
          return
        }
        countDown.value -= 1
      }, 1000)
    },
    onStop: () => {
      recEnd()
      linkLoaidng.value = false
      recLoading.value = false
    },
    onError: () => {
      debugger
      recEnd()
      linkLoaidng.value = false
      recLoading.value = false
    },
    onScore: (xml) => {
      ytRecord
        .MergeFramesToAudio()
        .then((audioInfo) => {
          if (!audioInfo) return
          if (xml) {
            URL.revokeObjectURL(wordResult.value.audioUrl || '')
            wordResult.value = xfXmlParseToScore(xml)[0]
            wordResult.value.audioUrl = URL.createObjectURL(audioInfo.blob)
          }
        })
        .catch((_err) => {
          ElMessage({
            showClose: true,
            message: '音频合成失败',
            type: 'error',
            duration: 3000
          })
        })
        .finally(() => {
          setTimeout(() => {
            recLoading.value = false
            recStatus.value = 0
          }, 500)
        })
    }
  })
}
// 结束录制
const recEnd = () => {
  isStatr.value = false
  countDown.value = countDownDefault
  clearInterval(timer)
}

const wordAudioRef = ref<HTMLAudioElement>()
const playWordAudio = () => {
  if (wordAudioPaused.value) {
    wordAudioRef.value?.play()
  } else {
    wordAudioRef.value?.pause()
  }
}
const wordAudioPaused = ref<boolean | undefined>(true)
const onAudioStatus = () => {
  wordAudioPaused.value = wordAudioRef.value?.paused
}

// 获取评测分数
const getScore = () => {
  ytRecord.end()
  recEnd()
  recLoading.value = true
}

const sectionResult = ref<WordScore | undefined>(cloneDeep(resultDefault))

const highlightWord = (text: string, word: string): string => {
  if (!word) return text // 如果关键词为空，直接返回原文本
  const regex = new RegExp(escapeRegExp(word), 'gi')
  return text.replace(
    regex,
    (match) => `<span style="color: var(--el-color-danger);">${match}</span>`
  )
}

// 转义正则表达式特殊字符（避免用户输入的关键词破坏正则匹配）
function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

onUnmounted(() => {
  if (wordAudio.value) {
    wordAudio.value.removeEventListener('play', onPlay)
    wordAudio.value.removeEventListener('pause', onPause)
  }
  recEnd()
})

interface WordData {
  word: string
  phonetic: string
  translation: string
  audio: string
  phoneticAm: string
  audioAm: string
  bilingual: any[]
  color: number
  typeId: number
  usPhonetic: string
  ukPhonetic: string
  collectFolderName: string
  explanations: { word: string; type: string; content: string }[]
  wordForms: { word: string; extendedFormType: string; extendedFormWord: string }[]
  bilingualExamples: {
    audio: string
    source: string
    target: string
  }[]
  dictionaryPhrases: string[]
}

const Tips = ref('')
const termName = ref('')
/**题目id（练习页点击单词时传入，收藏单词时作为 qid 关联题目） */
const qid = ref<number>()
const data = ref<WordData>()
const loading = ref(false)
emitter.on('word', (wordData) => {
  wordResult.value = cloneDeep(resultDefault)
  qid.value = wordData.qid
  collectCanceled.value = false

  if (wordData.sectionResult) {
    sectionResult.value = wordData.sectionResult
  } else {
    sectionResult.value = undefined
  }

  let word = wordData.wordStr
  termName.value = wordData.termName
  if (!word.trim()) return
  // 正则匹配出单词
  word = word
    .replace(/[\u4e00-\u9fa5]/g, '') // 去除中文
    .replace(/[^\w\s-']/g, '')
  // 移除掉'防止识别不出来
  if (word.endsWith("'")) {
    word = word.replace(/'$/, '')
  }
  Tips.value = word
  dialogVisible.value = true
  data.value = undefined
  getWordInfo(word)
})

const getWordInfo = (word: string) => {
  loading.value = true
  request
    .get<WordData>('/api/voice/getByWordV2?word=' + word)
    .then((res) => {
      data.value = res.data
      if (userStore.userInfo.userQuestionSetting?.wordAutoPronounce === 1) {
        const isAmerican = userStore.userInfo.userQuestionSetting?.spellingPreference !== 1
        const audioSrc = isAmerican ? res.data?.audioAm : res.data?.audio
        const accentIndex = isAmerican ? 1 : 0
        if (audioSrc) {
          nextTick(() => {
            play(audioSrc, accentIndex)
          })
        }
      }
    })
    .finally(() => {
      loading.value = false
    })
}

onUnmounted(() => {
  emitter.off('word')
  ytRecord.cancelRecording()
  stopAllAudio()
})

const test = ref(`url(${userStore.userInfo.icon})`)
</script>
<style lang="scss" scoped>
.word-definition {
  font-size: var(--el-font-size-medium);
  &:deep(.word-dialog) {
    padding-top: 15px;
    background: linear-gradient(160deg, #f6f2ff 0%, #fefeff 100%);
    .el-dialog__header {
      padding-right: 0;
      padding-bottom: 0;
      margin-top: 10px;
    }
    .el-dialog__footer {
      padding-top: 10px;
    }
  }

  &.vip {
    &:deep(.word-dialog) {
      background: linear-gradient(163deg, #ffefdc 0%, #fffbf8 100%);
    }

    .rec-status-text {
      background-color: #ffe8d6;
    }
    .play-status-icon {
      color: #e8a067;
    }
  }

  .play-status-icon {
    width: 20px;
    height: 20px;
    color: var(--el-color-primary);
    cursor: pointer;
    flex-shrink: 0;
  }

  & > div {
    padding: 20px;
    margin: -20px;

    .title {
      position: relative;
      display: flex;
      flex-direction: row;
      font-size: 32px;
      line-height: 32px;
      font-weight: 800;
      color: #1c1c1e;
      align-items: center;
      gap: 0 10px;
      &.vip {
        .word {
          &::after {
            background-color: #eaa36b;
          }
        }
      }
      .word {
        position: relative;
        z-index: 2;
        &::after {
          content: '';
          bottom: 0;
          left: 0;
          position: absolute;
          height: 6px;
          width: 100%;
          background-color: var(--el-color-primary);
          opacity: 0.27;
          z-index: 1;
        }
      }

      .copy {
        margin-top: 10px;
        width: 18.21px;
        height: 17.89px;
        background-image: url(@/assets/images/icon/fuzhi.png);
        background-size: cover;
        cursor: pointer;
      }

      .switch-tx {
        position: absolute;
        right: 0;
        display: flex;
        flex-direction: row;
        font-weight: 400;
        font-size: var(--el-font-size-base);
        color: var(--el-text-color-primary);
        font-style: normal;
        text-transform: none;
        align-items: center;
        justify-content: center;
        width: 170px;

        & .el-switch.vip {
          --el-switch-on-color: var(--el-color-warning);
        }
      }

      .switch-close-icon {
        display: flex;
        width: 47px;
        height: 22px;
        margin-left: 10px;
        align-items: center;
        justify-content: center;
        background-image: url(@/assets/images/icon/guan@2x.png);
        background-size: cover;
      }
    }

    .accent {
      display: flex;
      align-items: center;
      gap: 0 45px;
      padding-bottom: 20px;

      .accent-item {
        display: flex;
        align-items: center;
        text-align: left;
        gap: 0 15px;
        background: #fcfffe;
        border-radius: 10px;
        padding: 0 10px;
      }
    }

    .word-info {
      color: var(--el-text-color-primary);
      height: 30vh;
      overflow-y: auto;
      padding-right: 10px;
      .dto {
        margin-top: 10px;
        width: 9px;
        height: 9px;
        background: #ffffff;
        border: 2px solid #7568ff;
        border-radius: 50%;
      }
      .title {
        font-size: var(--el-font-size-medium);
        font-weight: bold;
        margin-bottom: 10px;
      }
      .explanations {
        text-align: left;
        padding-bottom: 20px;
        border-bottom: 1px dashed var(--el-text-color-disabled);
        display: flex;
        flex-direction: column;
        gap: 12px 0;
        .explanation-item {
          display: flex;
          align-items: flex-start;
          gap: 10px;

          .label {
            color: var(--el-text-color-secondary);
            padding-right: 8px;
          }

          .text {
            flex: 1;
          }
        }
      }
      .word-forms {
        text-align: left;
        padding-top: 20px;
        text-align: left;
        padding-bottom: 20px;
        border-bottom: 1px dashed var(--el-text-color-disabled);

        .word-forms-box {
          display: flex;
          flex-wrap: wrap;
          gap: 12px 27px;
          .word-forms-item {
            display: flex;
            align-items: flex-start;
            gap: 0 4px;
            .label {
              color: var(--el-text-color-secondary);
              padding-right: 8px;
              white-space: nowrap;
            }
            .text {
              flex: 1;
              white-space: nowrap;
            }
          }
        }
      }
      .examples-phrases {
        padding-top: 20px;
        text-align: left;
        display: flex;
        gap: 0 30px;

        .examples {
          text-align: left;
          flex: 1;
          .example-list {
            display: flex;
            flex-direction: column;
            gap: 18px 0;
            .example-item {
              display: flex;
              align-items: flex-start;
              gap: 0 7px;
              .example-info {
                flex: 1;
                .e {
                  margin-bottom: 4px;
                }
                .c {
                  color: var(--el-text-color-secondary);
                }
              }
            }
          }
        }
        .phrases {
          flex: 1;
          .phrases-list {
            display: flex;
            flex-direction: column;
            gap: 12px 0;
            .phrases-item {
              display: flex;
              align-items: flex-start;
              gap: 0 7px;
            }
          }
        }
      }
    }
    .audio-section {
      margin: 0 auto;
      margin-top: 33px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 393px;
      gap: 0 18px;

      .item {
        height: 54px;
        background: #ffffff;
        border-radius: 15px 15px 15px 15px;
        border: 1px solid #e8e6ef;
        display: flex;
        align-items: center;
        justify-content: center;

        &:nth-child(1) {
          width: 216px;
        }

        &:nth-child(2) {
          width: 159px;
        }

        &.icon {
        }
      }
    }

    .rec-status-text {
      margin: 0 auto;
      margin-top: 15px;
      width: 320px;
      background: #f1f0ff;
      border-radius: 36px 36px 36px 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      padding: 8px 0;
      font-size: var(--el-font-size-base);
      color: var(--el-text-color-primary);
    }

    .syll {
      font-size: var(--el-font-size-base);
    }

    .rec-box {
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0 56px;
      height: 60px;

      .score {
        width: 50px;
        height: 50px;
        background: #6f747a;
        border-radius: 50%;
        font-weight: bold;
        font-size: 22px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;

        & > span {
          transform: translateX(3px);
        }
      }

      .rec-control {
        cursor: pointer;
        width: 50px;
        height: 50px;

        .start-btn {
          display: block;
          width: 100%;
          height: 100%;
        }

        .end-btn {
          position: relative;
          width: 100%;
          height: 100%;
          :deep(.el-progress-circle) {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 50px !important;
            height: 50px !important;
          }
          :deep(.el-progress__text) {
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 10;
          }

          &.vip::after {
            background-color: #eaa26b;
          }

          &.vip {
            :deep(.el-progress-circle__track) {
              stroke: #ffe8d6;
            }
          }

          &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background-color: #8479ff;
            z-index: 1;
          }

          .end-rectangle {
            position: relative;
            width: 22px;
            height: 22px;
            background: #ffffff;
            border-radius: 4px;
          }
        }
      }

      .rec-audio {
        position: relative;
        width: 50px;
        height: 50px;
        background-image: v-bind(test);
        background-size: cover;
        border-radius: 50%;
        overflow: hidden;

        &::after {
          position: absolute;
          content: '';
          inset: 0;
          background-color: rgba(0, 0, 0, 0.3);
          z-index: 1;
        }

        .btn {
          margin: 0;
          padding: 0;
          width: 100%;
          height: 100%;
          position: relative;
          z-index: 10;
          display: flex;
          align-items: center;

          .play,
          .zt {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            display: block;
            width: 80%;
            height: 80%;
          }
        }
      }
    }

    .btn {
      margin-right: 30px;
      cursor: pointer;
      align-items: center;
      justify-content: flex-end;
      display: flex;
      flex-direction: row;

      img {
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      .text {
        font-weight: 400;
        font-size: var(--el-font-size-base);
        color: var(--el-text-color-primary);
        line-height: 34px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-left: 3px;
      }

      .line {
        height: 1em;
        width: 1px;
        background-color: #cecdd9;
        margin-left: 16px;
        margin-right: 16px;
      }
    }

    .collect-text {
      cursor: pointer;
      align-items: center;
      color: var(--el-color-primary);
      font-size: var(--el-font-size-base);
      display: inline-flex;
    }
  }
}
</style>
